export default {
	'loading.show': 'loading.show.paimai-h5',
	'loading.hide': 'loading.hide.paimai-h5',
	'AlertDialog.show': 'AlertDialog.show.paimai-h5',
	'ConfirmDialog.show': 'ConfirmDialog.show.paimai-h5',
	'evaluate.show': 'evaluate.show.paimai-h5',
}